import { z } from "zod"
import type { CustomerEmailTarget } from "./customer-email-contract"

export function crmMailtoTarget(href: string): CustomerEmailTarget {
  let url: URL
  try { url=new URL(href) } catch { throw new Error("This email link is invalid.") }
  if(url.protocol!=="mailto:")throw new Error("Choose an email link.")
  let address: string
  try { address=decodeURIComponent(url.pathname).trim() } catch { throw new Error("This email address is invalid.") }
  if(!z.email().max(254).safeParse(address).success)throw new Error("Choose a single valid email address.")
  if(url.searchParams.has("cc")||url.searchParams.has("bcc"))throw new Error("Copied recipients are not supported by this email link. Open the recipient's email address directly.")
  const subject=url.searchParams.get("subject")??"",initialMessage=url.searchParams.get("body")??""
  if(subject.length>240||/[\r\n]/.test(subject))throw new Error("This email link has an invalid subject.")
  if(initialMessage.length>12000)throw new Error("This email link's message is too long.")
  return {email:address.toLowerCase(),...(subject?{subject}:{}),...(initialMessage?{initialMessage}:{})}
}
